// src/lib/utils/date/parseIsoDate.ts

/**
 * Date ISO 8601 au format étendu : `AAAA-MM-JJ`, suivie ou non de `THH:MM`, de `:SS`, d'une fraction
 * de seconde et d'un fuseau (`Z` ou `±HH:MM`).
 */
const ISO_8601 =
    /^(\d{4})-(\d{2})-(\d{2})(?:T(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|[+-](?:[01]\d|2[0-3]):?[0-5]\d)?)?$/;

/**
 * Lit une date ISO 8601 (F-1.9). Toute autre forme rend `null`, même quand `Date` saurait la lire :
 * `new Date("05/03/2026")` donne le 3 mai, `new Date("2026-02-30")` le 2 mars. Les formes courtes
 * restent acceptées : `2026-06-24` (minuit UTC) ou une heure sans fuseau (heure locale), lues comme
 * par `Date`.
 */
export function parseIsoDate(value: unknown): Date | null {
    if (typeof value !== "string") {
        return null;
    }

    const match = ISO_8601.exec(value);
    if (!match) {
        return null;
    }

    // Jour qui existe au calendrier : `Date` reporterait le 30 février au 2 mars.
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const calendarDay = new Date(Date.UTC(year, month - 1, day));
    if (
        calendarDay.getUTCMonth() !== month - 1 ||
        calendarDay.getUTCDate() !== day
    ) {
        return null;
    }

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}
